import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";

export default class JurisdictionJobApplicationsService extends AbstractService {
	static endpoint = ENDPOINTS.jurisdictionApproval;

	static getAll({ queryParams, getCancelToken }) {
		return this.get({
			endpoint: this.endpoint,
			queryParams,
			getCancelToken,
		});
	}

	static getCounts() {
		return this.get({
			endpoint: `${this.endpoint}/counts`,
		});
	}

	static update({ queryParams, data }) {
		return this.post({
			endpoint: `${this.endpoint}`,
			data,
			queryParams,
		});
	}
}
